<div class="vflex-300">
  <h2>Date Pickers</h2>
  <div class="surface-muted border-radius-200 pad-200">
    <code>
      import &#123; DatePickerComponent &#125; from '&#64;spaces-ui/meadow/components/date-time';
    </code>
  </div>

  <h3>Date Picker (Button trigger style)</h3>
  <ng-template #datePicker data-sample="datePicker">
    <section class="vflex-300 flex-no-stretch">
      <mdw-date-picker [value]="value()" (valueChange)="value.set($event)"></mdw-date-picker>

      <div class="hflex-100">
        <p class="bold">Date Value:</p>
        <p class="secondary">{{ value() }}</p>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="datePicker" sampleName="datePicker"></app-sample>

  <hr />

  <h3>Date Picker (Input trigger style)</h3>
  <ng-template #dateInputPicker data-sample="dateInputPicker">
    <section class="vflex-300 flex-no-stretch">
      <mdw-date-picker
        triggerType="input"
        [value]="value()"
        (valueChange)="value.set($event)"
      ></mdw-date-picker>

      <div class="hflex-100">
        <p class="bold">Date Value:</p>
        <p class="secondary">{{ value() }}</p>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="dateInputPicker" sampleName="dateInputPicker"></app-sample>

  <hr />

  <h3>Date Range Picker</h3>
  <ng-template #dateRangePicker data-sample="dateRangePicker">
    <section class="vflex-300 flex-no-stretch">
      <mdw-date-range-picker
        dropdownPositionX="start"
        dropdownPositionY="above"
        [value]="rangeValue()"
        (valueChange)="rangeValue.set($event)"
      ></mdw-date-range-picker>

      <div class="hflex-100">
        <p class="bold">Date Value:</p>
        <p class="secondary">{{ rangeValue()?.startDate }} - {{ rangeValue()?.endDate }}</p>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="dateRangePicker" sampleName="dateRangePicker"></app-sample>

  <hr />

  <h3>Calendar (small)</h3>
  <ng-template #calendarSmall data-sample="calendarSmall">
    <section class="vflex-300 flex-no-stretch">
      <mdw-calendar
        size="small"
        [value]="calendarValue()"
        (valueChange)="calendarValue.set($event)"
      ></mdw-calendar>

      <div class="hflex-100">
        <p class="bold">Date Value:</p>
        <p class="secondary">{{ calendarValue() }}</p>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="calendarSmall" sampleName="calendarSmall"></app-sample>
</div>
